<template>
  <div class="txt-frame">
    <div class="edit-box" :class="{active: editClassNameActive}">
      <a :title="'Click to name this ' + context.toLowerCase()" class="experiment-class" @click="showEditClassName"><h3>{{heading}}</h3></a>
      <div v-if="text && text.hasKeys()" class="tooltip-holder">
        <a href="#" @click="starClicked" title="Favorite">
          <img v-if="!text.isFavorite()" class="estar tooltip-holder-img" src="../../assets/Star.png">
          <img v-else
               class="fillstar tooltip-holder-img"
               src="../../assets/starfill.png">
        </a>
        <div v-if="showFavoriteNeedsLogin" style="display:block" class="tooltip" @click="toolTipClicked">
          <a class="canceltooltip" href="#"><img class="tooltip-holder-img" src="../../assets/ic_cancel1.png"></a>
          <p>In order to add to favorites you must <a class="blue" href="#" @click="$store.commit('LOGIN_REQUESTED')">Sign in</a> or <a class="blue" href="#" @click="$store.commit('LOGIN_REQUESTED')">Sign
            up</a></p>
        </div>
      </div>
      <div class="field-holder">
        <input
            v-if="editClassNameActive"
            v-focus
            type="text" class="form-control" :placeholder="'Enter a name for this ' + context.toLowerCase()" v-model="modelForEditingName"
               @keyup.enter="finishNameEdit()" @focusout="cancelEditClassNameOnBlur">
        <!--handle both @click for the keyboard event if it's focused and @mousedown to catch the mouse event before the blur-->
        <a href="#" @click="finishNameEdit" ref="ok-icon" class="ok-icon" @mousedown="finishNameEdit()"><img src="../../assets/ic_tick.png"></a>
      </div>
    </div>
    <div class="textarea-holder">
      <button @click="$emit('show-select-text', text)" type="button" class="button lg bg-gray change hoverable">
        <span v-if="text && text.hasKeys()">Change</span>
        <span v-else>Select</span>
      </button>
      <div class="selectedtxt" :class="{error: showTooFewClassesError && !(text && text.hasKeys())}">
        <p v-if="text && text.hasKeys()">{{text.description}}</p>
        <p v-else class="no-text-yet">Click Select to choose text(s).</p>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<script>

import {StateChanges} from '../../store/stateChanges'

export default {
  name: 'ManageTextControl',
  props: ['text', 'placeholderName', 'showTooFewClassesError', 'context'],
  data () {
    return {
      editClassNameActive: false,
      favorite: false,
      showFavoriteNeedsLogin: false,
      modelForEditingName: ''
    }
  },
  computed: {
    heading () {
      return (this.text && this.text.name) || this.placeholderName
    }
  },
  methods: {
    starClicked () {
      if (this.$store.state.isLoggedIn) {
        this.$store.commit(StateChanges.SAVE_FAVORITE, { favorite: this.text, context: this.context || 'Favorite' })
      } else {
        this.showFavoriteNeedsLogin = true
      }
    },
    toolTipClicked () {
      this.showFavoriteNeedsLogin = false
      this.favorite = true
    },
    finishNameEdit () {
      if (this.modelForEditingName !== this.text.name) {
        this.text.setName(this.modelForEditingName)
      }
      this.editClassNameActive = false
    },
    showEditClassName () {
      this.editClassNameActive = true
    },
    cancelEditClassNameOnBlur (event) {
      if (event.relatedTarget === this.$refs['ok-icon']) {
        return
      }
      this.editClassNameActive = false
      this.modelForEditingName = this.text.name
    }
  },
  watch: {
    text: {
      handler () {
        this.modelForEditingName = this.text ? this.text.name : ''
      },
      immediate: true
    }
  }
}
</script>
<style scoped>
span {
  font-size: inherit;
  line-height: inherit;
}
button {
  width: 114px;
}
.no-text-yet {
  color: rgba(100,100,100,0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/experiment/manageTextControl.vue